import { ProductBuilderMachineContext } from '../types';
import { getBaseProduct } from './getBaseProduct';

type GetDayFabricPositionOptions = (
  context: ProductBuilderMachineContext,
) => string[];

export const getDayFabricPositionOptions: GetDayFabricPositionOptions = context => {
  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return [];
  const {
    metafields: { day_fabric_position },
  } = baseProduct;
  return day_fabric_position ? day_fabric_position : [];
};
